'use strict';
const mmWidgets = require('./mm-widgets'),
	goldPlanDescription = require('../models/gold-plan-description');
mmWidgets.fn.goldPlanOptionWidget = function (plan) {
	return mmWidgets.each(this, function () {
		const widget = this;
		widget.attr('value', JSON.stringify(plan));
		widget.text(goldPlanDescription(plan));
	});
};
